import { FC } from "react";
import { useTranslation } from "react-i18next";
import { PackageOpen } from "lucide-react";

const PaymentAgreementEmptyState: FC = () => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col items-center justify-center text-center px-6 py-14">
      <div className="relative mb-6">
        <div className="absolute inset-0 rounded-full bg-primary/10 blur-xl" />
        <div className="relative flex h-20 w-20 items-center justify-center rounded-full bg-gradient-to-br from-primary/10 to-primary/5 ring-1 ring-inset ring-primary/15">
          <PackageOpen className="h-9 w-9 text-primary/70" strokeWidth={1.5} />
        </div>
      </div>
      <h3 className="text-lg font-semibold text-foreground">
        {t("fe.pages.flow.steps.paymentMethod.emptyPlansTitle")}
      </h3>
      <p className="mt-2 max-w-sm text-sm leading-6 text-muted-foreground">
        {t("fe.pages.flow.steps.paymentMethod.emptyPlansDescription")}
      </p>
    </div>
  );
};

export default PaymentAgreementEmptyState;
